export class VentanillaUacPK {
    public numeroVentanilla: string;
    public sede: string;
}


export class VentanillaUACModel {
    public ventanillaUacPK: VentanillaUacPK;
    public estado: string;
    public motivoEspera: string;
    public fechaCreacion: Date;
    public fechaModificacion: Date;
    public usuarioModificacion: string;
    public descripcion: string;
    public nombre: string;
}